import React, { Component } from 'react';
import { Table, FormGroup, Input, Container } from "reactstrap"

class Markers extends Component {
  render() {
    const prescription = this.props.prescription;
    const rxStatus = this.props.prescriptionStatus;
    const notes = prescription?.notes || '';
    const fileUrl = notes?.split(' , ')[0]?.trim();
    const otherNotes = notes?.split(' , ').slice(1).join(' , ').trim();
    const fileType = this.getFileTypeFromUrl(fileUrl);
    const isValidFile = fileType !== 'unknown';
    console.log("=======Partial==============" + prescription.rxStatus);
    return (
      <Container style={{ height: '339px!important' }}>
        <Table borderless>
          <thead>
            <tr>
              <th>
                <i className="fas fa-caret-square-down mr-2" />
                Comments/Notes
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <FormGroup>
                  <textarea className="form-control" defaultValue={otherNotes}
                    disabled={rxStatus.toUpperCase() != 'DRAFT'}
                    id="shortDescription2" name="comments"
                    placeholder="Comment"
                    rows="3.5" onChange={this.props.save} />
                </FormGroup>
              </td>
            </tr>
            <tr>
              <th><i className="fas fa-caret-square-down mr-2" />
                Patient Allergy Information</th>
            </tr>
            <tr>
              <td>
                {isValidFile ? (
                  fileType === 'pdf' ? (
                    <iframe
                      src={fileUrl}
                      width="100%"
                      height="600px"
                      title="Allergy Info PDF"
                    />
                  ) : (
                    <img
                      src={fileUrl}
                      alt="Allergy Info Image"
                      style={{ maxWidth: '100%', maxHeight: '600px', display: 'block', margin: 'auto' }}
                    />
                  )
                ) : (
                  <div
                    style={{
                      width: '100%',
                      height: '600px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1px dashed #ccc',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    <span style={{ color: '#777' }}>Patient Information Pending</span>
                  </div>
                )}

              </td>
            </tr>
            <tr>
              <td className="text-left">
                <FormGroup>
                  {/* <div className="checkbox"
                                     style={{float: 'left', marginLeft: '2%'}}>
                                    <div
                                        className="custom-control custom-checkbox m-0">
                                        <Input className="custom-control-input" id="requireConsult"
                                               name="requireConsult"
                                               type="checkbox" defaultChecked={prescription.requireConsult}
                                               onChange={this.props.checked}/>
                                        <label className="custom-control-label text-uppercase"
                                               htmlFor="requireConsult">
                                            Require Consult</label></div>
                                </div> */}
                  <div className="checkbox"
                    style={{ float: 'left', marginLeft: '2%' }}>
                    <div
                      className="custom-control custom-checkbox m-0">
                      <Input className="custom-control-input" id="onHold"
                        name="onHold"
                        type="checkbox" defaultChecked={prescription.onHold}
                        onChange={this.props.checked} />
                      <label className="custom-control-label text-uppercase"
                        htmlFor="onHold">
                        On-Hold</label></div>
                  </div>
                  <div className="checkbox"
                    style={{ float: 'left', marginLeft: '2%' }}>
                    <div
                      className="custom-control custom-checkbox m-0">
                      <Input className="custom-control-input" id="partial"
                        name="partial"
                        type="checkbox" defaultChecked={prescription.partial}
                        onChange={this.props.checked} />
                      <label className="custom-control-label text-uppercase"
                        htmlFor="partial">
                        Partial</label>
                    </div>
                  </div>

                  {/* <div className="checkbox"

                                
                                     style={{float: 'left', marginLeft: '2%'}}>
                                    <div
                                        className="custom-control custom-checkbox m-0">
                                        <Input className="custom-control-input" id="patientWaiting"
                                               name="patientWaiting"
                                               type="checkbox" defaultChecked={prescription.patientWaiting}
                                               onChange={this.props.checked}/>
                                        <label className="custom-control-label text-uppercase"
                                               htmlFor="patientWaiting">
                                            Patient Waiting</label>
                                    </div>
                                </div> */}

                  {/* <div className="checkbox" style={{float: 'left', marginLeft: '2%'}}>
                                    <span><Input id="patientWaiting"
                                        name="patientWaiting"
                                        type="checkbox" onChange={this.props.checked}/>
                                        <label>PatientWaiting</label></span>
                                    </div> */}
                </FormGroup>
              </td>
            </tr>
          </tbody>
        </Table>

      </Container>
    );
  }

  getFileTypeFromUrl(url) {
    if (!url) return 'unknown';
    const extension = url.split('.').pop().toLowerCase();
    if (extension === 'pdf') return 'pdf';
    if (['jpg', 'jpeg', 'png'].includes(extension)) return 'image';
    return 'unknown';
  }
  getMimeTypeFromBase64(base64) {
    if (!base64) return 'application/octet-stream';
    try {
      if (base64.startsWith('data:')) {
        return base64.split(';')[0].split(':')[1]; // returns 'application/pdf' or 'image/png'
      }
      const firstChar = atob(base64.slice(0, 10)).charCodeAt(0);
      if (firstChar === 0x25) return 'application/pdf'; // '%PDF'
      if (firstChar === 0xFF) return 'image/jpeg';
      if (firstChar === 0x89) return 'image/png';
    } catch (e) { }
    return 'application/octet-stream';
  }


  isValidBase64File(base64String, fileType) {
    if (!base64String) return false;
    try {
      const decoded = atob(base64String.slice(0, 50));
      if (fileType === 'pdf') {
        return decoded.includes('%PDF');
      } else if (fileType === 'image') {
        return (
          decoded.charCodeAt(0) === 0xFF || // JPEG
          decoded.charCodeAt(0) === 0x89    // PNG
        );
      }
      return false;
    } catch (e) {
      return false;
    }
  }
}

export default Markers;
